export enum EmailEnum {
  invoicingSupport = 'EdgeInvoicingSupport@xpo.com',
};
